// Format date time to "19 Nov 2025 10:00:00"
export const formatDateTime = (date: string) => {
	// if date is not a date return —
	const dateObj = new Date(date);
	if (isNaN(dateObj.getTime())) {
		return "—";
	}
	return dateObj
		.toLocaleDateString("en-GB", {
			year: "numeric",
			month: "short",
			day: "numeric",
			hour: "2-digit",
			minute: "2-digit",
			second: "2-digit",
			hour12: false,
		})
		.replace(",", "");
};

// Format date to "19 Nov 2025"
export const formatDateDdMmmYyyy = (date: string | undefined) => {
	if (!date) return "—";
	const dateObj = new Date(date);
	if (isNaN(dateObj.getTime())) {
		return "—";
	}
	return dateObj.toLocaleDateString("en-GB", {
		year: "numeric",
		month: "short",
		day: "numeric",
	});
};

// Format date to "19 Nov 2025, 17:30:21 UTC"
export const formatDateTimeUtc = (date: string) => {
	const dateObj = new Date(date);
	if (isNaN(dateObj.getTime())) {
		return "—";
	}
	return (
		dateObj.toLocaleString("en-GB", {
			timeZone: "UTC",
			year: "numeric",
			month: "short",
			day: "numeric",
			hour: "2-digit",
			minute: "2-digit",
			second: "2-digit",
			hour12: false,
		}) + " UTC"
	);
};
